import { gql } from '@apollo/client';

export const COURSES = gql`
  query courses {
    course {
      id
      name
      duration
      partTime
    }
  }
`;

export const COURSES_FOR_SELECT = gql`
  query courses_for_select {
    course {
      id
      code
      name
    }
  }
`;

export const COURSES_FOR_STUDENT_LOG_BOOK_SELECT = gql`
  query courses_for_select_student_log_book_select {
    course {
      id
      code
      name
      course_semesters {
        id
        semester
      }
    }
  }
`;

export const INSERT_COURSE = gql`
  mutation insert_course($objects: [course_insert_input!]!) {
    insert_course(objects: $objects) {
      affected_rows
    }
  }
`;

export const COURSE_LIST = gql`
  subscription courseList($where: course_bool_exp, $order_by: [course_order_by!]) {
    course(where: $where, order_by: $order_by) {
      id
      code
      name
      partTime
      duration
      course_semesters {
        id
        semester
        weeksPerSemester
        course_semester_subjects_subjects {
          subject {
            id
            code
            name
            hoursPerSlot
            minutesPerSlot
            totalSlots
          }
        }
      }
    }
  }
`;

export const DELETE_COURSE = gql`
  mutation delete_course($where: course_bool_exp!) {
    delete_course(where: $where) {
      affected_rows
    }
  }
`;

export const COURSE = gql`
  query course($where: course_bool_exp) {
    course(where: $where) {
      id
      code
      name
      partTime
      duration
      course_semesters {
        id
        semester
        course_level {
          id
          name
        }
        weeksPerSemester
        course_semester_subjects_subjects {
          subject {
            id
            code
            name
            hoursPerSlot
            minutesPerSlot
            totalSlots
          }
        }
      }
    }
  }
`;

export const UPDATE_COURSE = gql`
  mutation update_course($where: course_bool_exp!, $_set: course_set_input) {
    update_course(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const INSERT_COURSE_SEMESTER = gql`
  mutation insert_course_semester($objects: [course_semester_insert_input!]!) {
    insert_course_semester(objects: $objects) {
      affected_rows
    }
  }
`;

export const UPDATE_COURSE_SEMESTER = gql`
  mutation update_course_semester($_set: course_semester_set_input, $where: course_semester_bool_exp!) {
    update_course_semester(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const DELETE_COURSE_SEMESTER = gql`
  mutation delete_course_semester($where: course_semester_bool_exp!) {
    delete_course_semester(where: $where) {
      affected_rows
    }
  }
`;

export const INSERT_COURSE_SEMESTER_SUBJECT = gql`
  mutation insert_course_semester_subjects_subject($objects: [course_semester_subjects_subject_insert_input!]!) {
    insert_course_semester_subjects_subject(objects: $objects) {
      affected_rows
    }
  }
`;

export const DELETE_COURSE_SEMESTER_SUBJECT = gql`
  mutation delete_course_semester_subjects_subject($where: course_semester_subjects_subject_bool_exp!) {
    delete_course_semester_subjects_subject(where: $where) {
      affected_rows
    }
  }
`;

export const COURSES_FOR_TIMETABLE = gql`
  query courses_for_timetable {
    course {
      id
      name
    }
  }
`;

export const COURSE_FOR_TIMETABLE = gql`
  query course_for_timetable($where: course_bool_exp) {
    course(where: $where) {
      id
      name
      course_semesters {
        id
        semester
        weeksPerSemester
        course_semester_subjects_subjects {
          subject {
            id
            code
            color
            hoursPerSlot
            minutesPerSlot
            totalSlots
            subject_to_users(order_by: { priority: asc }) {
              user {
                id
                firstName
                employeeID
              }
            }
          }
        }
      }
      batches {
        id
        name
        year
        intake {
          name
          month
        }
        batch_classes {
          id
          name
        }
      }
    }
  }
`;

export const COURSES_FOR_TIMETABLE_SELECT = gql`
  query courses_for_timetable_select {
    course {
      id
      name
      code
      course_semesters {
        id
        semester
        weeksPerSemester
      }
    }
  }
`;

export const COURSES_FOR_RESULT_SHEET = gql`
  query coursesForResultSheet($where: course_bool_exp) {
    course(where: $where) {
      id
      name
      code
      course_semesters {
        id
        semester
        course_semester_subjects_subjects {
          subject {
            id
            name
            code
          }
        }
      }
    }
  }
`;
